import React from "react";

interface Props {
    fill: string;
}

export const PrivacyIcon: React.FC<Props> = ({ fill }) => {
    return (
        <svg height="24px" viewBox="0 0 24 24" width="24px" fill={fill}>
            <path d="M21,5l-9-4L3,5v6c0,5.55,3.84,10.74,9,12c2.3-0.56,4.33-1.9,5.88-3.71l-3.12-3.12c-1.94,1.29-4.58,1.07-6.29-0.64 c-1.95-1.95-1.95-5.12,0-7.07c1.95-1.95,5.12-1.95,7.07,0c1.71,1.71,1.92,4.35,0.64,6.29l2.9,2.9C20.29,15.69,21,13.38,21,11V5z" />
            <circle cx="12" cy="12" r="3" />
        </svg>
    );
};
